export default __webpack_public_path__ + "static/media/health_experiences.d0e14aad.png";